import React, { useEffect } from 'react';
import { DropletIcon, FlaskConicalIcon, ArrowRightIcon } from 'lucide-react';
import { trackSectionView, trackContentEngagement } from './MetaPixelTracker';
export function HiddenKnowledge() {
  useEffect(() => {
    // Track section view when component mounts
    trackSectionView('HiddenKnowledge');
  }, []);
  const scrollToPricingOptions = () => {
    trackContentEngagement('navigation', 'ver_producto_button', 'click');
    // Find the element with the text "Ahora… solo hacelo real."
    const elements = document.querySelectorAll('p');
    for (const element of elements) {
      if (element.textContent?.includes('Ahora… solo hacelo real.')) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
        break;
      }
    }
  };
  return <section className="py-16 border-b border-gray-800" data-id="element-253">
      <div className="max-w-3xl mx-auto" data-id="element-254">
        <h2 className="text-3xl font-bold mb-8 text-left" data-id="element-255">
          <span className="bg-gradient-to-r from-red-500 to-orange-500 text-transparent bg-clip-text" data-id="element-256">
            Conocimiento Oculto
          </span>
        </h2>
        <div className="flex flex-col md:flex-row gap-8 mb-10" data-id="element-257">
          <div className="md:w-1/2" data-id="element-258">
            <p className="text-lg mb-6" data-id="element-259">
              ImpulseX no es otro suplemento. Es una fórmula ancestral, mejorada
              con ciencia moderna. Elaborada con precisión bioquímica,
              fusionando extractos como Tongkat Ali, Guaraná y Canela sagrada.
            </p>
            <p className="text-lg" data-id="element-260">
              No es marketing. Es activación celular. Una alquimia entre
              naturaleza e intención.
            </p>
          </div>
          <div className="md:w-1/2 bg-gray-900 rounded-lg p-6 border border-gray-800" data-id="element-261">
            <h3 className="text-xl font-bold mb-4 flex items-center" data-id="element-262">
              <DropletIcon className="h-5 w-5 text-red-500 mr-2" data-id="element-263" />
              Cada gota contiene lo que estudios han demostrado:
            </h3>
            <div className="space-y-4" data-id="element-264">
              <div className="flex items-start" onClick={() => trackContentEngagement('benefit', 'aumenta_vitalidad', 'click')} data-id="element-265">
                <span className="text-red-500 mr-2 flex-shrink-0" data-id="element-266">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor" data-id="element-267">
                    <path d="M12 2L4 12l8 10 8-10L12 2z" data-id="element-268" />
                  </svg>
                </span>
                <p data-id="element-269">Aumenta la vitalidad masculina.</p>
              </div>
              <div className="flex items-start" onClick={() => trackContentEngagement('benefit', 'potencia_deseo', 'click')} data-id="element-270">
                <span className="text-red-500 mr-2 flex-shrink-0" data-id="element-271">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor" data-id="element-272">
                    <path d="M12 2L4 12l8 10 8-10L12 2z" data-id="element-273" />
                  </svg>
                </span>
                <p data-id="element-274">Potencia el deseo natural.</p>
              </div>
              <div className="flex items-start" onClick={() => trackContentEngagement('benefit', 'estimula_respuesta', 'click')} data-id="element-275">
                <span className="text-red-500 mr-2 flex-shrink-0" data-id="element-276">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor" data-id="element-277">
                    <path d="M12 2L4 12l8 10 8-10L12 2z" data-id="element-278" />
                  </svg>
                </span>
                <p data-id="element-279">Estimula la respuesta física y mental.</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-10" data-id="element-280">
          <h3 className="text-2xl font-bold mb-6 text-center" data-id="element-281">
            <span className="bg-gradient-to-r from-red-500 to-orange-500 text-transparent bg-clip-text" data-id="element-282">
              Beneficios del ImpulseX
            </span>
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-283">
            <div className="bg-gray-900 rounded-lg p-5 border border-gray-800 hover:border-red-500 transition-colors" onClick={() => trackContentEngagement('benefit_detail', 'vitalidad_masculina', 'click')} data-id="element-284">
              <div className="flex items-center mb-2" data-id="element-285">
                <div className="w-10 h-10 mr-3 flex items-center justify-center" data-id="element-286">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8 text-red-500" data-id="element-287">
                    <path d="M18 8h1a4 4 0 0 1 0 8h-1" data-id="element-288"></path>
                    <path d="M5 8h1a4 4 0 0 1 0 8H5" data-id="element-289"></path>
                    <path d="M6 8V6a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v2" data-id="element-290"></path>
                    <path d="M6 16v2a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-2" data-id="element-291"></path>
                  </svg>
                </div>
                <h4 className="text-lg font-bold text-red-500" data-id="element-292">
                  Vitalidad masculina renovada
                </h4>
              </div>
              <p className="text-gray-300 pl-12" data-id="element-293">
                Más energía natural, fuerza que se siente, estado físico que
                acompaña tus días sin agotamiento.
              </p>
            </div>
            <div className="bg-gray-900 rounded-lg p-5 border border-gray-800 hover:border-red-500 transition-colors" onClick={() => trackContentEngagement('benefit_detail', 'deseo_autentico', 'click')} data-id="element-294">
              <div className="flex items-center mb-2" data-id="element-295">
                <div className="w-10 h-10 mr-3 flex items-center justify-center" data-id="element-296">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" className="w-8 h-8" data-id="element-297">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" fill="url(#paint0_linear)" data-id="element-298" />
                    <path d="M12 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z" fill="url(#paint1_linear)" data-id="element-299" />
                    <defs data-id="element-300">
                      <linearGradient id="paint0_linear" x1="2" y1="12" x2="22" y2="12" gradientUnits="userSpaceOnUse" data-id="element-301">
                        <stop stopColor="#ff4136" data-id="element-302" />
                        <stop offset="1" stopColor="#ff7a36" data-id="element-303" />
                      </linearGradient>
                      <linearGradient id="paint1_linear" x1="6" y1="12" x2="18" y2="12" gradientUnits="userSpaceOnUse" data-id="element-304">
                        <stop stopColor="#ff4136" data-id="element-305" />
                        <stop offset="1" stopColor="#ff7a36" data-id="element-306" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h4 className="text-lg font-bold text-red-500" data-id="element-307">
                  Deseo auténtico
                </h4>
              </div>
              <p className="text-gray-300 pl-12" data-id="element-308">
                Reavivar el interés íntimo sin presiones, una motivación interna
                que nace de vos.
              </p>
            </div>
            <div className="bg-gray-900 rounded-lg p-5 border border-gray-800 hover:border-red-500 transition-colors" onClick={() => trackContentEngagement('benefit_detail', 'claridad_mental', 'click')} data-id="element-309">
              <div className="flex items-center mb-2" data-id="element-310">
                <div className="w-10 h-10 mr-3 flex items-center justify-center" data-id="element-311">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" className="w-8 h-8" data-id="element-312">
                    <path d="M12 3.5C7.58 3.5 4 7.08 4 11.5c0 2.38 1.05 4.5 2.71 5.97C7.53 18.24 8.5 19.5 8.5 21h7c0-1.5.97-2.76 1.79-3.53C18.95 16 20 13.88 20 11.5c0-4.42-3.58-8-8-8z" fill="url(#paint0_linear)" data-id="element-313" />
                    <path d="M12 6.5c-2.76 0-5 2.24-5 5 0 .51.1 1 .27 1.46.39-.17.83-.26 1.28-.26 1.66 0 3 1.34 3 3 0 .35-.07.68-.18 1h1.26c-.11-.32-.18-.65-.18-1 0-1.66 1.34-3 3-3 .45 0 .89.09 1.28.26.17-.46.27-.95.27-1.46 0-2.76-2.24-5-5-5z" fill="url(#paint1_linear)" data-id="element-314" />
                    <defs data-id="element-315">
                      <linearGradient id="paint0_linear" x1="4" y1="12.25" x2="20" y2="12.25" gradientUnits="userSpaceOnUse" data-id="element-316">
                        <stop stopColor="#ff4136" data-id="element-317" />
                        <stop offset="1" stopColor="#ff7a36" data-id="element-318" />
                      </linearGradient>
                      <linearGradient id="paint1_linear" x1="7" y1="11.35" x2="17" y2="11.35" gradientUnits="userSpaceOnUse" data-id="element-319">
                        <stop stopColor="#ff4136" data-id="element-320" />
                        <stop offset="1" stopColor="#ff7a36" data-id="element-321" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h4 className="text-lg font-bold text-red-500" data-id="element-322">
                  Claridad mental & enfoque
                </h4>
              </div>
              <p className="text-gray-300 pl-12" data-id="element-323">
                Menos neblina mental; más concentración, más capacidad para
                estar presente en lo que hacés.
              </p>
            </div>
            <div className="bg-gray-900 rounded-lg p-5 border border-gray-800 hover:border-red-500 transition-colors" onClick={() => trackContentEngagement('benefit_detail', 'respuesta_fisica', 'click')} data-id="element-324">
              <div className="flex items-center mb-2" data-id="element-325">
                <div className="w-10 h-10 mr-3 flex items-center justify-center" data-id="element-326">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" className="w-8 h-8" data-id="element-327">
                    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" fill="url(#paint0_linear)" stroke="url(#paint1_linear)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-328" />
                    <defs data-id="element-329">
                      <linearGradient id="paint0_linear" x1="3" y1="12" x2="21" y2="12" gradientUnits="userSpaceOnUse" data-id="element-330">
                        <stop stopColor="#ff4136" data-id="element-331" />
                        <stop offset="1" stopColor="#ff7a36" data-id="element-332" />
                      </linearGradient>
                      <linearGradient id="paint1_linear" x1="3" y1="12" x2="21" y2="12" gradientUnits="userSpaceOnUse" data-id="element-333">
                        <stop stopColor="#ff4136" data-id="element-334" />
                        <stop offset="1" stopColor="#ff7a36" data-id="element-335" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h4 className="text-lg font-bold text-red-500" data-id="element-336">
                  Respuesta física potente
                </h4>
              </div>
              <p className="text-gray-300 pl-12" data-id="element-337">
                Mejor rendimiento corporal, reacción rápida, mayor resistencia.
              </p>
            </div>
            <div className="bg-gray-900 rounded-lg p-5 border border-gray-800 hover:border-red-500 transition-colors md:col-span-2" onClick={() => trackContentEngagement('benefit_detail', 'bienestar_integral', 'click')} data-id="element-338">
              <div className="flex items-center mb-2" data-id="element-339">
                <div className="w-10 h-10 mr-3 flex items-center justify-center" data-id="element-340">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" className="w-8 h-8" data-id="element-341">
                    <path d="M12 2L9.19 8.63 2 9.24l5 4.87-1.18 6.89L12 17l6.18 4-1.18-6.89 5-4.87-7.19-.61L12 2z" fill="url(#paint0_linear)" stroke="url(#paint1_linear)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-342" />
                    <defs data-id="element-343">
                      <linearGradient id="paint0_linear" x1="2" y1="12" x2="22" y2="12" gradientUnits="userSpaceOnUse" data-id="element-344">
                        <stop stopColor="#ff4136" data-id="element-345" />
                        <stop offset="1" stopColor="#ff7a36" data-id="element-346" />
                      </linearGradient>
                      <linearGradient id="paint1_linear" x1="2" y1="12" x2="22" y2="12" gradientUnits="userSpaceOnUse" data-id="element-347">
                        <stop stopColor="#ff4136" data-id="element-348" />
                        <stop offset="1" stopColor="#ff7a36" data-id="element-349" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h4 className="text-lg font-bold text-red-500" data-id="element-350">
                  Bienestar integral
                </h4>
              </div>
              <p className="text-gray-300 pl-12 mb-4" data-id="element-351">
                Un cuerpo y mente alineados: no solo lo físico, también el
                estado emocional mejora.
              </p>
            </div>
          </div>
          <div className="flex justify-center mt-6" data-id="element-352">
            <button onClick={scrollToPricingOptions} className="bg-gradient-to-r from-red-500 to-orange-500 text-white py-2 px-6 rounded-full flex items-center gap-2 hover:from-red-600 hover:to-orange-600 transition-all shadow-lg" data-id="element-353">
              Ver producto <ArrowRightIcon className="h-4 w-4" data-id="element-354" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}